export enum ModalType {
    Offer = 0,
    Bid = 1,
    Checkout = 2,
}
